"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _paymentHelpers = require("./paymentHelpers");

var _PaymentMethodButtonsModule = _interopRequireDefault(require("./PaymentMethodButtons.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Modules
// Utils
// Styles
function generateButtons(selected, arr, callback) {
  return arr.map(function (button) {
    var paymentType = button.paymentType,
        amount = button.amount,
        heading = button.heading,
        description = button.description,
        isPopular = button.isPopular,
        paymentMethod = button.paymentMethod;
    var isSelected = selected === paymentType;
    return /*#__PURE__*/_react.default.createElement("button", {
      className: "".concat(isSelected ? [_PaymentMethodButtonsModule.default.btn, _PaymentMethodButtonsModule.default.btnSelected].join(' ') : _PaymentMethodButtonsModule.default.btn, " ").concat(paymentType === _paymentHelpers.paymentTypes.savedCard ? _PaymentMethodButtonsModule.default.savedCard : ''),
      onClick: function onClick() {
        return callback(paymentType);
      },
      key: "".concat(paymentType).concat(amount),
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _PaymentMethodButtonsModule.default.verticalAlign
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: isSelected ? [_PaymentMethodButtonsModule.default.circle, _PaymentMethodButtonsModule.default.circleSelected].join(' ') : _PaymentMethodButtonsModule.default.circle
    }, isSelected ? /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'check-circle']
    }) : /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['far', 'circle']
    }))), paymentType !== _paymentHelpers.paymentTypes.savedCard && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: _PaymentMethodButtonsModule.default.firstCol
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: _PaymentMethodButtonsModule.default.heading
    }, heading), /*#__PURE__*/_react.default.createElement("p", {
      className: _PaymentMethodButtonsModule.default.description
    }, description)), /*#__PURE__*/_react.default.createElement("div", null, paymentType === _paymentHelpers.paymentTypes.installments && /*#__PURE__*/_react.default.createElement("p", {
      className: _PaymentMethodButtonsModule.default.amount
    }, /*#__PURE__*/_react.default.createElement("sup", null, "$"), amount, /*#__PURE__*/_react.default.createElement("sub", null, "/m")), isPopular ? /*#__PURE__*/_react.default.createElement("span", {
      className: _PaymentMethodButtonsModule.default.isPopular
    }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'star']
    }), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        marginLeft: '5px',
        lineHeight: '1em'
      }
    }, "Popular")) : null)), paymentType === _paymentHelpers.paymentTypes.savedCard && generateSavedCardButton(paymentMethod));
  });
}

var generateSavedCardButton = function generateSavedCardButton(paymentMethod) {
  if (paymentMethod) {
    var logo = paymentMethod.logo,
        full_name = paymentMethod.full_name,
        last_four = paymentMethod.last_four,
        expiration_month = paymentMethod.expiration_month,
        expiration_year = paymentMethod.expiration_year;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: _PaymentMethodButtonsModule.default.firstCol
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: logo,
      alt: "Saved card logo"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _PaymentMethodButtonsModule.default.secondCol
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "".concat(_PaymentMethodButtonsModule.default.description, " ").concat(_PaymentMethodButtonsModule.default.topRow)
    }, /*#__PURE__*/_react.default.createElement("strong", null, full_name)), /*#__PURE__*/_react.default.createElement("p", {
      className: _PaymentMethodButtonsModule.default.description
    }, "Ending in ", last_four)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
      className: "".concat(_PaymentMethodButtonsModule.default.description, " ").concat(_PaymentMethodButtonsModule.default.topRow)
    }, "EXP ", expiration_month, "/", expiration_year), /*#__PURE__*/_react.default.createElement("p", {
      className: "".concat(_PaymentMethodButtonsModule.default.description, " ").concat(_PaymentMethodButtonsModule.default.placeHolder)
    }, "PLACEHOLDER")));
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

var PaymentMethodButtons = function PaymentMethodButtons(props) {
  var selected = props.selected,
      clickHandler = props.clickHandler,
      buttons = props.buttons,
      gaEventHandlers = props.gaEventHandlers;

  var handleClick = function handleClick(value) {
    clickHandler(value);
  };

  (0, _react.useEffect)(function () {
    if (typeof (gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.load) === 'function') gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.load();
    /**
     * We only want this to run once when the component loads
     * so it is safe to ignore the hooks/exhaustive-deps warning
     */
    // eslint-disable-next-line
  }, []);

  if (buttons.length < 2) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }

  return /*#__PURE__*/_react.default.createElement("section", {
    className: _PaymentMethodButtonsModule.default.container
  }, generateButtons(selected, buttons, handleClick));
};

var _default = PaymentMethodButtons;
exports.default = _default;